
import { useSelector } from "react-redux";
import { PlayheadCanvas, Waveform } from "../components/Waveform";
import { getSampleLibraryManagerInstance } from '../SamplePlayer';
import { useEffect, useState } from "react";
import { lerp, normalize } from "../utils/math";
import { ParameterSliderRange } from "../parameterWidgets/ParameterSliderRange";
import { getPadParameterName } from "../instruments/Sampler";

export function SamplerWaveform({className, instrument, selectedPad}) {
    const soundName = useSelector(instrument.getDisplayParameterSelector("sound"));
    const isReverse = useSelector(instrument.getDisplayParameterSelector(getPadParameterName(selectedPad, "isReverse")));

    return <fieldset data-widget-id="padWaveformDisplay" className={`waveform-cropper ${className}`}>
        <div className="stack h-full">
            <Waveform  soundName={soundName} isReverse={isReverse}/>
            <SamplerEnvelopeOverlay instrument={instrument} selectedPad={selectedPad} />
            <PlayheadCanvas getPlayheadPosition={() => instrument.getSoundPlayersWithPadPlaying(selectedPad).map(player => player.player.position) } />
        </div>
        <ParameterSliderRange pt={{ handle: { "data-widget-id": "padSlicer" }}} instrument={instrument} parameterHandlers={[instrument.getParameterHandler(getPadParameterName(selectedPad, "start")), instrument.getParameterHandler(getPadParameterName(selectedPad, "end"))]} noLabel noOutput/>
    </fieldset>
}

function SamplerEnvelopeOverlay({instrument, selectedPad}) {
    const attack = useSelector(instrument.getDisplayParameterSelector(getPadParameterName(selectedPad, "attack")));
    const release = useSelector(instrument.getDisplayParameterSelector(getPadParameterName(selectedPad, "release")));
    const start = useSelector(instrument.getDisplayParameterSelector(getPadParameterName(selectedPad, "start")));
    const end = useSelector(instrument.getDisplayParameterSelector(getPadParameterName(selectedPad, "end")));
    
    const soundName = useSelector(instrument.getDisplayParameterSelector("sound"));
    const [duration, setDuration] = useState(0);
    
    useEffect(() => {
        getSampleLibraryManagerInstance().getBufferForSound(soundName, buffer => setDuration(buffer.duration));
    }, [soundName]);

    const endTime = end * duration;
    let isEnvelopeCropped = false;
    const envelope = [{time: start * duration, value: 0}];
    let attackEndTime = start * duration + attack;
    let attackEndValue = 1;
    if (endTime < attackEndTime) {
        isEnvelopeCropped = true;
        attackEndValue = normalize(endTime, start*duration, attackEndTime);
        attackEndTime = endTime;
    }
    envelope.push({time: attackEndTime, value: attackEndValue});
    if (!isEnvelopeCropped) {
        let releaseStartTime = end * duration - release;
        const releaseStartValue = 1;
        if (releaseStartTime < attackEndTime) releaseStartTime = attackEndTime;
        else envelope.push({time: releaseStartTime, value: releaseStartValue});
        let releaseEndTime = releaseStartTime + release;
        let releaseEndValue = 0;
        if (endTime < releaseEndTime) {
            isEnvelopeCropped = true;
            releaseEndValue = 1 - normalize(endTime, releaseStartTime, releaseEndTime);
            releaseEndTime = endTime;
        }
        envelope.push({time: releaseEndTime, value: releaseEndValue});
    }
    if (isEnvelopeCropped) envelope.push({time: endTime, value: 0})
    

    let pathString = envelope.reduce((pathString, point) => {
        return pathString + ` L ${point.time} ${1 - point.value}`;
    }, `M ${envelope[0].time} ${envelope[0].value}`);
    envelope.toReversed().slice(1).forEach(point => {
        pathString += ` L ${point.time} ${1 + point.value}`;
    })
    
    const strokeWidthPx = 3;
    return <svg viewBox={`0 0 ${duration} 2`} preserveAspectRatio="none" className="w-full h-full">
        <g fill="color-mix(in srgb, var(--accent-color) 30%, transparent)" stroke="var(--accent-color)" strokeWidth={strokeWidthPx} strokeLinecap="round" strokeLinejoin="round">
            <path d={pathString} vectorEffect="non-scaling-stroke"></path>
        </g>
    </svg>
}